/* eslint-disable */
import React, { Component } from 'react';
import cIf from 'classnames';
import PropTypes from 'prop-types';

import { EventDateInfo } from '.';
import { EventDateInfo as EventDateInfoModel } from '../../../mvcapi/models/common';
import { filter, map, some } from 'lodash';


var getMomentTZDateTime = require('ts-util').getMomentTZDateTime;


//items: EventDateInfo[],

export type EventDateInfoRowProps = {
    items: EventDateInfoModel[],
    selectedItemIDs: number[],
    hidePackageEventDetailLink: boolean,
    overview: boolean,
    homeUrl: string,
    isFixedPackage: boolean,
    isMandatory: boolean,
    onEventDateClick: (eventDateID: number, isSelected: boolean, isMandatory: boolean) => void
};

export type EventDateInfoRowState = { };

export class EventDateInfoRow extends Component<EventDateInfoRowProps, EventDateInfoRowState> { 
    constructor(props) {
        super(props);

        this.handleEventDateClick = this.handleEventDateClick.bind(this);
    }

    handleEventDateClick(eventDateID, isSelected, isMandatory) {
        this.props.onEventDateClick(eventDateID, isSelected, isMandatory);
    }

    isItemSelected(itemID) {
        return some(this.props.selectedItemIDs, (id) => id == itemID )
    }

    render() {

        // Sort by date?

        var itemsToShow = this.props.items;

        // If in overview mode, we only show stuff that is selected
        if(this.props.overview)
            itemsToShow = filter(itemsToShow, (i) => this.isItemSelected(i.EventDateID));

        var itemInfos = map(itemsToShow, function(item) {
            return <EventDateInfo
                        key={item.EventDateID}
                        id={item.EventDateID}
                        name={item.Description}
                        venueName={item.VenueName}
                        productInfoUrl={item.MediaInfo.ProductInfoURL}
                        productPictureUrl={item.MediaInfo.PictureThumbnailURL}
                        dateString={getMomentTZDateTime(item.Date, item.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}
                        isNewDate={item.IsNewDate}
                        isFixedPackage={this.props.isFixedPackage}
                        isMandatory={this.props.isMandatory}
                        hidePackageEventDetailLink={this.props.hidePackageEventDetailLink}
                        overview={this.props.overview}
                        homeUrl={this.props.homeUrl}
                        onClick={this.handleEventDateClick}
                        seatsAvailability={item.SeatsAvailability}
                        selected={this.isItemSelected(item.EventDateID)}
            />;
        }.bind(this));

        var content = null;
        if(itemsToShow.length > 0) {
            content = (
                <div className="row">
                    {itemInfos}
                </div>
            );
        }

        return content;
    }
};

